import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const WeeklySkeleton = (props) => {
  const listArray = [...Array(11)];
  return (
    <div className="dashboard-right-side-skeleton">
      {listArray.map((e, i) => (
        <div key={i}>
          <Skeleton borderRadius="5rem" className="dashboard-right-side-skeleton-row-title" inline />
          <Skeleton borderRadius="5rem" className="dashboard-right-side-skeleton-row-content" inline />
        </div>
      ))}
    </div>
  );
};
export default WeeklySkeleton;
